export type SolarFormValues = {
  solarKwdc?: string | number;
  solarKwac?: string | number;
  solarAnnualProduction?: string | number;
  newSolarKwdc?: string | number;
  newSolarKwac?: string | number;
  newSolarAnnualProduction?: string | number;
};

export type SolarSelection = {
  hasExistingSolar: boolean;
  hasNewSolar: boolean;
};

/**
 * Appends the six solar size fields to a project payload.
 *
 * SDCP-1322: unchecking a solar type has to send its fields as empty strings, not omit them.
 * The submit helpers skip empty values, so a cleared field was never sent, the API left the old
 * numbers in place, and reopening the project re-ticked the checkbox from the stale value — the
 * removal appeared to be ignored.
 *
 * A selected type keeps the previous behaviour: values are sent, and blanks are skipped so a
 * partially filled form does not wipe stored data.
 */
export const appendSolarFields = (
  formData: FormData,
  values: SolarFormValues,
  { hasExistingSolar, hasNewSolar }: SolarSelection
): void => {
  const append = (
    key: string,
    value: string | number | undefined,
    isSelected: boolean
  ) => {
    if (!isSelected) {
      formData.append(key, "");
      return;
    }
    if (value === undefined || value === null) return;
    const stringValue = String(value);
    if (stringValue !== "") {
      formData.append(key, stringValue);
    }
  };

  append("solarKwdc", values.solarKwdc, hasExistingSolar);
  append("solarKwac", values.solarKwac, hasExistingSolar);
  append("solarAnnualProduction", values.solarAnnualProduction, hasExistingSolar);

  append("newSolarKwdc", values.newSolarKwdc, hasNewSolar);
  append("newSolarKwac", values.newSolarKwac, hasNewSolar);
  append(
    "newSolarAnnualProduction",
    values.newSolarAnnualProduction,
    hasNewSolar
  );
};

export default appendSolarFields;
